import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type { LC_SaveLocationEmployeesIn } from '../checkInLocation.types';


export class LocationEmployeesSaveService {
  async save(
    locationId: number,
    body: LC_SaveLocationEmployeesIn,
  ): Promise<ApiResponse<void>> {
    return apiClient.patch<void>(
      API_CONFIG.ENDPOINTS.CHECK_IN_LOCATION.EMPLOYEES_SAVE(locationId),
      body,
    );
  }
}

export const locationEmployeesSaveService = new LocationEmployeesSaveService();
